import platform from '../platform';

export const versionCompare = (ver1: string, ver2: string): number => {
  if (platform.isSkApp) {
    // 数科 app 内，版本比较 默认返回1
    return 1;
  }
  const v1 = ver1 || '0.0.0';
  const v2 = ver2 || '0.0.0';
  if (v1 === v2) {
    return 0;
  }
  const v1Arr = v1.split('.');
  const v2Arr = v2.split('.');
  const len = Math.max(v1Arr.length, v2Arr.length);
  for (let i = 0; i < len; i += 1) {
    const v1Item = Number(v1Arr[i] || 0);
    const v2Item = Number(v2Arr[i] || 0);
    if (v1Item < v2Item) {
      return -1;
    }
    if (v1Item > v2Item) {
      return 1;
    }
  }
  return 0;
};
